// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const ideaInDescriptionMax = 8000;

export const ideaInSourceUrlsItemMax = 2000;

export const ideaInSourceUrlsMax = 10;

export const ideaInTitleMax = 200;

export const IdeaIn = zod.object({
  "description": zod.string().min(1).max(ideaInDescriptionMax),
  "industry_id": zod.union([zod.uuid(),zod.null()]).optional(),
  "source_urls": zod.array(zod.string().max(ideaInSourceUrlsItemMax)).max(ideaInSourceUrlsMax).optional(),
  "title": zod.string().min(1).max(ideaInTitleMax)
});

export type IdeaIn = zod.input<typeof IdeaIn>;
export type IdeaInOutput = zod.output<typeof IdeaIn>;
